var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 45.125H42.1875M9.375 6.875H40.625M10.9375 6.875V45.125M39.0625 6.875V45.125M18.75 14.8438H21.875M18.75 21.2188H21.875M18.75 27.5938H21.875M28.125 14.8438H31.25M28.125 21.2188H31.25M28.125 27.5938H31.25M18.75 45.125V37.9531C18.75 36.6328 19.7993 35.5625 21.0938 35.5625H28.9062C30.2007 35.5625 31.25 36.6328 31.25 37.9531V45.125",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.06e774a6dce8b81c60b9d42316c01889.svg";
export { ForwardRef as ReactComponent };